import PropTypes from "prop-types";
import {useT} from "../i18n/i18n";
import HeartIcon from "./HeartIcon";
import {SITE_CONFIG} from "../config/siteConfig";
import {Link} from "react-router-dom";

export default function Footer({language}) {
    const {t} = useT(language);
    const year = new Date().getFullYear();

    const navLink = ({to, href, label, isExternal = false, ariaLabel}) => {
        const baseClasses = "text-xs sm:text-sm text-white hover:text-white/80 focus:outline-none focus:ring-2 focus:ring-white/40 focus:ring-offset-2 focus:ring-offset-black rounded px-2.5 py-1 transition-all duration-200 hover:bg-white/10 focus:bg-white/15";
        
        if (isExternal) {
            return (
                <a href={href} target="_blank" rel="noopener noreferrer" className={baseClasses} aria-label={ariaLabel}>
                    {label}
                </a>
            );
        }
        
        if (href?.startsWith("mailto:")) {
            return (
                <a href={href} className={baseClasses} aria-label={ariaLabel}>
                    {label}
                </a>
            );
        }
        
        return (
            <Link to={to} className={baseClasses} aria-label={ariaLabel}>
                {label}
            </Link>
        );
    };

    return (
        <>
            {/* Full-width separator line */}
            <div className="w-screen relative left-1/2 -translate-x-1/2 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
            
            <div className="w-screen relative left-1/2 -translate-x-1/2 bg-black">
                <footer role="contentinfo" className="w-full">
                    <div className="max-w-6xl mx-auto px-4 sm:px-6">
                        {/* Footer Content - Compact */}
                        <div className="py-8 sm:py-10">
                            {/* Single Row Layout */}
                            <div className="flex flex-col sm:flex-row items-center justify-between gap-6 sm:gap-4">
                                {/* Legal Links */}
                                <nav aria-label={language === "en" ? "Legal Information" : "Informazioni Legali"} className="order-2 sm:order-1">
                                    <ul className="flex flex-wrap justify-center sm:justify-start gap-1">
                                        <li>
                                            {navLink({to: "/privacy-policy", label: language === "en" ? "Privacy" : "Privacy", ariaLabel: "Read our privacy policy"})}
                                        </li>
                                        <li className="text-white opacity-20 px-1">•</li>
                                        <li>
                                            {navLink({to: "/terms-of-service", label: language === "en" ? "Terms" : "Termini", ariaLabel: "Read our terms of service"})}
                                        </li>
                                        <li className="text-white opacity-20 px-1">•</li>
                                        <li>
                                            {navLink({href: "https://www.iubenda.com/privacy-policy/", label: language === "en" ? "Cookies" : "Cookie", isExternal: true, ariaLabel: "Manage cookie preferences"})}
                                        </li>
                                    </ul>
                                </nav>

                                {/* Copyright & P.IVA - Center on mobile */}
                                <div className="order-1 sm:order-2 text-center sm:text-right">
                                    <div className="text-xs text-white flex items-center justify-center sm:justify-end gap-1">
                                        {"\u00A9"} {year} {" "} 
                                        {t("footer.designedBy")}{" "}
                                        <HeartIcon 
                                            className="inline-block text-white hover:text-red-500 transition-colors duration-200 cursor-pointer flex-shrink-0" 
                                            size={11} 
                                            aria-hidden="true"
                                        />
                                    </div>
                                    {SITE_CONFIG.piva && (
                                        <div className="text-xs text-white/60 mt-1">
                                            P.IVA {SITE_CONFIG.piva}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

Footer.propTypes = {
    language: PropTypes.oneOf(["en", "it"]),
};
